var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",style:({ '--current-color': _vm.theme })},[_c('div',{staticClass:"top-bar"},[_c('Navbar')],1),_c('div',{staticStyle:{"height":"50px"}}),_c('div',{staticClass:"body-box"},[_c('div',{staticClass:"body-left"},[_c('Sidebar')],1),_c('div',{staticClass:"body-right"},[_c('AppMain')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }